import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ExoAvatar from '../exo/ExoAvatar';
import CardContainer from './layout/CardContainer';
import Typography from '@mui/material/Typography';
import { getClientName } from '../special/clientName';

const ProjectCard = ({ project }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <CardContainer
      onClick={project ? () => navigate(`/projects/${project.id}`) : undefined}
    >
      {project ? (
        <>
          <Typography variant="h6">{t('Project')}</Typography>
          <ExoAvatar
            type={
              project.clientType === 'internal' ? 'company' : project.clientType
            }
            picture={
              project.client
                ? project.client.logo?.temporaryUrl || ''
                : '/logo.svg'
            }
            name={getClientName(project)}
          />
          <Typography variant="h4">{project.name}</Typography>
        </>
      ) : (
        <Typography>{t('No project')}</Typography>
      )}
    </CardContainer>
  );
};

export default ProjectCard;
